// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2tHdt","head":"ProcedureTableInfo_head__2PSfV"};